import axiosClient from '@clients/axiosClient';
import { Program } from '@clients/domains/programs/program';
import { ProgramParameter } from '@clients/domains/programs/programParameters';

type programId = { programId: number };

export type GetProgramDetails = programId;
export type GetProgramParameters = programId;

export type ProgramParameters = {
    pages: number;
    current_page: number;
    per_page: number;
    total_items: number;
    items: ProgramParameter[];
};

const programs = () => {
    const client = axiosClient();

    return {
        async getProgramDetails({ programId }: GetProgramDetails) {
            const { data } = await client.get<Program>(
                `programs/v1/programs/${programId}`,
            );
            return data;
        },
        async getProgramParameters({ programId }: GetProgramParameters) {
            const { data } = await client.get<ProgramParameters>(
                `programs/v1/programs/${programId}/parameters?perPage=200`,
            );
            return data;
        },
    };
};

export default programs;
